import { render, staticRenderFns } from "./CancelResult.vue?vue&type=template&id=12e3d530&scoped=true"
import script from "./CancelResult.vue?vue&type=script&lang=js"
export * from "./CancelResult.vue?vue&type=script&lang=js"
import style0 from "./CancelResult.vue?vue&type=style&index=0&id=12e3d530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e3d530",
  null
  
)

export default component.exports